import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import styled from 'styled-components';

export const DeviceCardStyled = styled(PocCard)`
    &.no-border {
        owc-component-header {
            border-bottom: unset;
        }
    }

    .device-card-content {
        display: flex;
        flex-direction: column;
        padding: 0 16px 30px;

        .dropdown-container {
            width: 50% !important;
        }

        div.block.inline {
            > owc-select-dropdown,
            owc-typography {
                flex: 1;
            }

            owc-typography {
                padding-bottom: 0;
                color: #706b69;
            }

            &.no-options {
                padding-top: 14px;

                owc-typography {
                    width: 50%;
                }
            }
        }
    }
`;
